import React from 'react';
import './Loading.scss';

export const Loading = (): React.JSX.Element => {
    return (
        <div className="loader-container" role="status" aria-label="Loading">
            <div className="spinner-border Loading-Spinner" />
            <span className="Loading-Text">Loading...</span>
        </div>
    );
};
